import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

interface StepProps {
    active: boolean;
    label: string;
    number: number;
    sx?: SxProps;
}

const boxContainerSx: SxProps = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    p: 3,
};

const labelSx: SxProps = {
    color: 'grey.200',
    fontStyle: 'normal',
    lineHeight: 1.5,
    textAlign: 'center',
    zIndex: 100,
};

const stepCircleSx: SxProps<Theme> = {
    '&::before': {
        backgroundColor: 'primary.light',
        border: (th) => `1px solid ${th.palette.primary.main}`,
        borderRadius: '50%',
        content: "''",
        display: 'block',
        height: '100%',
        width: '100%',
    },
    height: 48,
    position: 'relative',
    width: 48,
};

const stepNumberSx: SxProps = {
    color: 'primary.main',
    fontStyle: 'normal',
    fontWeight: 600,
    left: '50%',
    lineHeight: 1.625,
    position: 'absolute',
    textAlign: 'center',
    top: '50%',
    transform: 'translate(-50%, -50%)',
};

const Step: FC<StepProps> = ({ active, label, number, sx }) => (
    <Box
        data-test-id={`step-${number}`}
        sx={{
            ...boxContainerSx,
            ...sx,
        }}
    >
        <Box mx="auto" position="relative" sx={stepCircleSx}>
            {number && (
                <Typography sx={stepNumberSx} variant="h4">
                    {number}
                </Typography>
            )}
        </Box>
        {label && (
            <Typography
                fontWeight={active ? 'bold' : 'normal'}
                mt={2}
                sx={labelSx}
                variant="body1"
                whiteSpace="pre-line"
            >
                {label}
            </Typography>
        )}
    </Box>
);

export default Step;
